var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62854 0.800018C4.23134 0.800018 0.662598 4.36876 0.662598 8.76596C0.662598 13.1632 4.23134 16.7319 8.62854 16.7319C13.0257 16.7319 16.5945 13.1632 16.5945 8.76596C16.5945 4.36876 13.0257 0.800018 8.62854 0.800018ZM9.42514 12.7489H7.83195V7.96937H9.42514V12.7489ZM9.42514 6.37618H7.83195V4.78299H9.42514V6.37618Z",
    fill: "#678EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b2f508b503dbd1a9fae73203b98583b3.svg";
export { ForwardRef as ReactComponent };